import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  data: () => ({
    tabActive: 'work',
    tabs: [
      {
        name: 'Заказы в работе',
        path: 'work',
      },
      {
        name: 'Архив заказов',
        path: 'archived',
      },
    ],
  }),

  computed: {
    ...mapGetters('user', ['getDealer']),
    ...mapGetters('account/orders', ['getTriggerUpdateOrdersList']),

    isOrdersArchived() {
      if (this.tabActive === 'archived') {
        return true;
      }

      return false;
    },
  },

  watch: {
    getTriggerUpdateOrdersList(newVal) {
      if (newVal) {
        this.updateOrders()
        this.setTriggerUpdateOrdersList(false)
      }
    },
  },

  methods: {
    ...mapActions('account/orders', ['setOrders']),

    ...mapMutations('account/orders', ['updatePage', 'updatePerpage', 'setTriggerUpdateOrdersList']),

    updateOrdersTab(path) {
      const query = {};

      if (path === 'archived') {
        query.tab = path;
      }

      this.tabActive = path;
      this.updatePage(1);
      this.updatePerpage(localStorage.per_page ? localStorage.per_page : 25);

      this.updateOrders().finally(() => {
        this.compareOrdersRoute(query);
      });
    },

    compareOrdersRoute(query) {
      if (JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
        this.$router.push({
          query: query,
          hash: this.$route.hash,
        });
      }
    },

    updateOrders(data) {
      this.togglePreload(true);
      let filters;

      if (data) {
        filters = data;
      } else {
        filters = this.$route.query;
      }

      return this.setOrders({
        type: this.type,
        filters,
        archived: this.isOrdersArchived,
      }).finally(() => {
        this.togglePreload(false);
      });
    },

    setOrdersPage() {
      if (this.$route.query?.page > 1) {
        this.updatePage(this.$route.query.page);
      } else {
        this.updatePage(1);
      }
    },

    setOrdersPerPage() {
      if (localStorage.per_page) {
        this.updatePerpage(localStorage.per_page);
      }
    },
  },

  created() {
    this.togglePreload(true);
    this.setOrdersPerPage();
    this.setOrdersPage();

    let query = { ...this.$route.query };

    if (query?.tab === 'archived') {
      this.tabActive = this.tabs[1].path;
    } else {
      delete query.tab;
    }

    this.updateOrders(query).finally(() => {
      this.compareOrdersRoute(query);
    });
    window.scrollTo(0, 0);
  },
};
